import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import { uploadClass } from './styles';
import Progress from '../Progress';
import Spin from '../Spin';
import icons from '../icons';
import { ERROR, UPLOADING } from './request';
import { getDirectionClass } from '../utils/classname';
var SPIN =
/*#__PURE__*/
React.createElement("span", {
  style: {
    display: 'inline-block',
    marginRight: 8
  }
},
/*#__PURE__*/
React.createElement(Spin, {
  size: 10,
  name: "ring"
}));

var File =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(File, _PureComponent);

  var _super = _createSuper2(File);

  function File(props) {
    var _this;

    _classCallCheck(this, File);

    _this = _super.call(this, props);
    _this.handleRemove = _this.handleRemove.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(File, [{
    key: "handleRemove",
    value: function handleRemove() {
      this.props.onRemove(this.props.id);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          message = _this$props.message,
          name = _this$props.name,
          status = _this$props.status,
          process = _this$props.process;
      var className = uploadClass('view-file', status === ERROR && 'error');
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: className
        },
        /*#__PURE__*/
        React.createElement("div", {
          className: uploadClass(getDirectionClass('text'))
        }, status === UPLOADING && SPIN, " ", name, " ", message &&
        /*#__PURE__*/
        React.createElement("span", null, "(", message, ") ")),
        /*#__PURE__*/
        React.createElement("a", {
          className: uploadClass('delete'),
          onClick: this.handleRemove
        }, icons.Close), status !== ERROR &&
        /*#__PURE__*/
        React.createElement(Progress, {
          className: uploadClass('progress'),
          background: process >= 0 ? '#e9ecef' : 'transparent',
          value: process,
          strokeWidth: 2
        }))
      );
    }
  }]);

  return File;
}(PureComponent);

export default File;